export class DropdownItemModel {
  id: string | number | undefined;
  name: string | undefined;
}

export const ITEM_PER_PAGE = [10, 25, 50, 100, 250, 500, 1000];
